export default "__VITE_ASSET__89188e4b__"